export default __webpack_public_path__ + "static/media/1177.d3054ba3.png";